export default "__VITE_ASSET__BN3jUixj__"